import { createContext, useContext } from 'react';

type TitlebarContext = {
  overrideTitlebar?(
    desktopTitle: string,
    mobileTitle: string,
    backLink: string
  ): void;
};
export const TitlebarContext = createContext<TitlebarContext | undefined>(
  undefined
);

export const { Provider: TitlebarContextProvider } = TitlebarContext;

export const useTitlebarContext = () => {
  const context = useContext(TitlebarContext);
  if (!context) {
    throw new Error(
      'useTitlebarContext must be used within an TitlebarContextProvider'
    );
  }
  return context;
};
